module.exports = __webpack_public_path__ + "static/media/success.d563771d.svg";